import type { User, UserRole } from '../modules/platform/types';
import { USER_ROLES } from './constants';

/** Must match analytics-service `require_audit_reader` (JWT roles). */
const AUDIT_ROLES = new Set<string>(['DEV_TEAM', 'ADMIN', 'SUPER_ADMIN', USER_ROLES.DEV_TEAM]);

export function hasAuditConsoleAccess(user: User | null | undefined): boolean {
  if (!user?.roles?.length) return false;
  return user.roles.some((r) => AUDIT_ROLES.has(String(r).toUpperCase()));
}

export const AUDIT_ROUTE_ROLES: UserRole[] = [USER_ROLES.DEV_TEAM, 'ADMIN', 'SUPER_ADMIN'];
